// AccountLinkModalは廃止 - ログイン必須のため
import React from 'react';

interface AccountLinkModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLinkSuccess: () => void;
}

const AccountLinkModal: React.FC<AccountLinkModalProps> = ({ isOpen, onClose, onLinkSuccess }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <h2 className="text-xl font-bold mb-4">ログイン必須</h2>
        <p className="text-gray-600 mb-4">
          匿名ユーザー機能は廃止されました。Googleまたはメールアドレスでログインしてください。
        </p>
        <button
          onClick={onClose}
          className="w-full bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600"
        >
          閉じる
        </button>
      </div>
    </div>
  );
};

export default AccountLinkModal;